import { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import { Link } from "react-router-dom";
import { STATUS_LABELS, SIGN_TYPES } from "@/lib/constants";
import "leaflet/dist/leaflet.css";

const STATUS_HEX = {
  COMPLIANT: "#059669", NON_COMPLIANT: "#E1000F", REJECTED: "#E1000F",
  INSTALLED: "#0d9488", APPROVED: "#059669", MANUFACTURER_SELECTION: "#7c3aed",
  QUOTE_PENDING: "#7c3aed", UNDER_REVIEW: "#d97706", SUBMITTED: "#000091",
};
const hex = (s) => STATUS_HEX[s] || "#000091";

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length) {
      const b = points.map((p) => [p.lat, p.lng]);
      try { map.fitBounds(b, { padding: [40, 40], maxZoom: 14 }); } catch {}
    }
  }, [points, map]);
  return null;
}

export default function SignsMap({ applications }) {
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");

  const filtered = applications.filter((a) => a.geo?.lat && a.geo?.lng)
    .filter((a) => !status || a.status === status)
    .filter((a) => !type || a.sign_type === type)
    .map((a) => ({ ...a, lat: parseFloat(a.geo.lat), lng: parseFloat(a.geo.lng) }));

  const center = filtered.length ? [filtered[0].lat, filtered[0].lng] : [46.6, 2.3];
  const statuses = [...new Set(applications.map((a) => a.status))];

  return (
    <div className="card-flat p-5">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <span className="text-xs uppercase tracking-[0.2em] text-slate-500 mr-2">Filtres</span>
        <select data-testid="map-filter-status" value={status} onChange={(e) => setStatus(e.target.value)} className="border border-input px-3 py-1.5 text-sm bg-white outline-none focus:ring-2 focus:ring-[#000091]">
          <option value="">Tous statuts</option>
          {statuses.map((s) => <option key={s} value={s}>{STATUS_LABELS[s] || s}</option>)}
        </select>
        <select data-testid="map-filter-type" value={type} onChange={(e) => setType(e.target.value)} className="border border-input px-3 py-1.5 text-sm bg-white outline-none focus:ring-2 focus:ring-[#000091]">
          <option value="">Tous types</option>
          {SIGN_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
        <span className="text-sm text-slate-500 ml-auto">{filtered.length} enseigne(s)</span>
      </div>
      <div className="h-[460px] border border-border" data-testid="signs-map">
        <MapContainer center={center} zoom={6} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
          <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <FitBounds points={filtered} />
          {filtered.map((a) => (
            <CircleMarker key={a.id} center={[a.lat, a.lng]} radius={9} pathOptions={{ color: "#fff", weight: 2, fillColor: hex(a.status), fillOpacity: 0.9 }}>
              <Popup>
                <div className="text-sm">
                  <div className="font-bold">{a.commercial?.business_name || a.merchant_name}</div>
                  <div className="text-slate-500 font-mono text-xs mb-1">{a.reference}</div>
                  <div>{a.sign_type} · {STATUS_LABELS[a.status] || a.status}</div>
                  <Link to={`/app/dossier/${a.id}`} className="text-[#000091] font-semibold underline">Ouvrir le dossier</Link>
                </div>
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
